import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountIdShorten',
  standalone: true
})
export class AccountIdShortenPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    if (value.length < 3) {
      return value;
    }
    return `••• ${value.slice(-2)}`;
  }
}
